import Vue from 'vue'

export default {
    UPDATE_PINNEDMSG (state, value) {
        Vue.set(state, 'pinnedmsgs', value);
    },
  SET_PINNEDMSGS (state, value) {
        this.commit('UPDATE_PINNEDMSG', value);
    },
    SET_SELECTED_PINNEDMSG (state,  value ) {
      Vue.set(state, 'selectedPinnedMsg', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/pinned/mutations.js